import { Image, StyleSheet, View } from 'react-native';

const backgroundImage = require('../../assets/background-app.png');

type GradientBackgroundProps = {
  fullHeight?: boolean;
};

export default function GradientBackground({ fullHeight = false }: GradientBackgroundProps) {
  return (
    <View pointerEvents="none" style={styles.container}>
      <Image source={backgroundImage} style={fullHeight ? styles.fullImage : styles.image} resizeMode="cover" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    aspectRatio: 1536 / 2764,
  },
  fullImage: {
    ...StyleSheet.absoluteFillObject,
    width: '100%',
    height: '100%',
  },
});
